module.exports = __webpack_public_path__ + "img/bg.e3c75195.jpg";